import {AfterContentInit, Directive, Injector, Input, OnDestroy} from "@angular/core";
import {AbstractSelectColumnComponent} from "./abstract-select-column.component";
import {EntityData} from "@fedeltapointofsale/data-client";
import {FormGroup} from "@angular/forms";

@Directive()
export class AbstractSingleSelectColumnComponent extends AbstractSelectColumnComponent implements AfterContentInit, OnDestroy {
    @Input() clearSelectionOptionLabel: string;
    @Input() allowClearSelectionOption: boolean = true;
    @Input() cellClassGetter: (this: void, formGroup: FormGroup, dataItem: any) => any;
    @Input() hidePlaceHolderOnCell: boolean;

    @Input() overrideRequired: boolean;

    constructor(injector: Injector, valueField?: string, labelField?: string) {
        super(injector, valueField, labelField);
    }

    getCellSummary(entity: EntityData<any>): string {
        const value: any = EntityData.getField(entity, this.field);
        if (value == undefined) {
            if (this.hidePlaceHolderOnCell) {
                return " ";
            } else {
                const placeholder: string = this.getPlaceholder(entity);
                return placeholder ? this.translateService.instant(placeholder) : undefined;
            }
        }
        if (this.data && this.data.length) {
            const option: any = this.data.find(o => o[this.valueField] === value);
            return option ? option[this.labelField] : undefined;
        } else {
            return EntityData.getField(entity, this.labelField);
        }
    }

    getClearSelectionOptionLabel(entity: EntityData<any>): string {
        return this.clearSelectionOptionLabel;
    }
}
